import { action } from 'mobx';
import SurveyModel from '../../../models/Maintenance/Survey/SurveyModel';
import BaseStore from '../../BaseStore';

export default class SurveyStore extends BaseStore {
  constructor(transportLayer) {
    super(SurveyModel, transportLayer);
  }

  @action fetchItems({ station_id, date_from, date_to }) {
    this.isLoading = true;
    this.items = [];

    const handleFetchAllSuccess = fetchedItems => {
      fetchedItems.forEach(json => {
        this.updateItemFromServer(json);
      });
      this.isLoading = false;
      return fetchedItems;
    };

    return this.transportLayer.fetch(station_id, date_from, date_to)
      .then(action(handleFetchAllSuccess))
      .catch(action(err => {
        console.log('err', err);
        this.isLoading = false;
        return Promise.reject(err);
      }));
  }
};


// WEBPACK FOOTER //
// ./src/stores/Maintenance/Survey/SurveyStore.js